import { render, staticRenderFns } from "./CruiseSliderArrowButton.vue?vue&type=template&id=23cc5632&scoped=true&"
import script from "./CruiseSliderArrowButton.vue?vue&type=script&lang=js&"
export * from "./CruiseSliderArrowButton.vue?vue&type=script&lang=js&"
import style0 from "./CruiseSliderArrowButton.vue?vue&type=style&index=0&id=23cc5632&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cc5632",
  null
  
)

export default component.exports